module.exports = __webpack_public_path__ + "img/4.aa2f5fde.webp";